import '../modules/perf-scaffold-sk';
import '../modules/report-page-sk';
